import { render, staticRenderFns } from "./RmrSegmentedControl.vue?vue&type=template&id=077e0733&scoped=true&"
import script from "./RmrSegmentedControl.vue?vue&type=script&lang=js&"
export * from "./RmrSegmentedControl.vue?vue&type=script&lang=js&"
import style0 from "./RmrSegmentedControl.vue?vue&type=style&index=0&id=077e0733&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077e0733",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
